import IdListDTO from '../IdListDTO';
import AssetDTO from '../asset/assetDTO';
import ProcessingActivity_TranslationDTO from './processingActivity_TranslationDTO';
import StringValueDTO from '../stringValue/stringValueDTO';
import TaskDTO from '../tasks/taskDTO';

export default class ProcessingActivityDTO {
  processingActivityId: number;

  code: string;

  ownerId?: string;

  ownerRoleId?: string;

  commentTrailId: number;

  auditTrailId: number;

  processingActivityStateId: number;

  processingActivityRoleId: number;

  trans: ProcessingActivity_TranslationDTO[];

  authSchemaId?: number;

  tasks: TaskDTO[];

  recipients: AssetDTO[];

  recipientCategories: StringValueDTO[];

  processors: AssetDTO[];

  data: AssetDTO[];

  jointControllers: AssetDTO[];

  responsibleEntitiesTenants?: IdListDTO;

  tagIds?: IdListDTO;

  created?: string;

  startDate?: string;

  endDate?: string;

  approvalDate?: string;

  taskId_DPIA: number | undefined;

  dpiaTask?: TaskDTO;

  dataSubjects: StringValueDTO[];
  
  dataCategories: StringValueDTO[];
  
  legalBases: StringValueDTO[];
  
  executingEntities: StringValueDTO[];
  
  retentionPeriod?: StringValueDTO;

  dataSubjectScale?: StringValueDTO;

  constructor() {
    this.processingActivityId = -1;
    this.code = '';
    this.commentTrailId = 0;
    this.auditTrailId = 0;
    this.processingActivityStateId = 0;
    this.processingActivityRoleId = 0;
    this.recipients = [];
    this.recipientCategories = [];
    this.processors = [];
    this.data = [];
    this.jointControllers = [];
    this.trans = [];
    this.tasks = [];
    this.dataSubjects = [];
    this.dataCategories = [];
    this.legalBases = [];
    this.executingEntities = [];
  }
}